<template>
	<ClickAway
		class="giphy-picker"
		eventName="mousedown"
		@away="onClose"
		:class="{ open: show }"
	>
		<div
			class="giphy-button"
			@click="show = true"
			@keyup.enter.stop="show = true"
		>
			<slot />
		</div>
		<Giphy
			class="giphy"
			v-if="show"
			@click="onClick"
			@close="onClose"
			aria-label="select gif"
		/>
	</ClickAway>
</template>

<script>
import ClickAway from './ClickAway'
import Giphy from '../Giphy'
import { addEscapeListener, removeEscapeListener } from '@/helpers/escape'

export default {
	name: 'GiphyPicker',
	components: { Giphy, ClickAway },
	data() {
		return { show: false }
	},
	beforeUnmount() {
		removeEscapeListener(this.escapeId)
	},
	emits: ['showGiphy', 'change'],
	watch: {
		show(show) {
			EventBus.$emit('showGiphy', show)
			if (show) {
				this.escapeId = addEscapeListener(() => this.onClose())
			} else {
				removeEscapeListener(this.escapeId)
			}
		},
	},
	methods: {
		onClick(gif) {
			this.$emit('change', gif)
			this.onClose()
		},
		onClose() {
			this.show = false
		},
	},
}
</script>
<style lang="scss" scoped>
.giphy-picker {
	position: relative;
	.giphy-button {
		/* works better with accessibility highlighting */
		height: 24px;
	}
}
</style>
